import { I_ADDRS, Q_ADDRS } from "../../plc-sim/library";
import { store, useTick } from "../../plc-sim/store";

function Row({ addr, value }: { addr: string; value: boolean }) {
  return (
    <div className="flex items-center justify-between gap-2 rounded border border-border px-2 py-1 font-mono text-[11px]">
      <span>{addr}</span>
      <span
        className="h-3 w-3 rounded-full"
        style={{ background: value ? "var(--lad-live)" : "var(--color-muted)" }}
      />
    </div>
  );
}

export function IoTable() {
  useTick();
  const mem = store.mem;
  return (
    <div className="grid grid-cols-2 gap-3 p-3" dir="rtl">
      <div>
        <p className="mb-1.5 text-[11px] font-semibold text-muted-foreground">Inputs</p>
        <div className="grid gap-1">
          {I_ADDRS.map((a) => (
            <Row key={a} addr={a} value={mem.bit(a)} />
          ))}
        </div>
      </div>
      <div>
        <p className="mb-1.5 text-[11px] font-semibold text-muted-foreground">Outputs</p>
        <div className="grid gap-1">
          {Q_ADDRS.map((a) => (
            <Row key={a} addr={a} value={mem.bit(a)} />
          ))}
        </div>
      </div>
    </div>
  );
}
